import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const VoteStatus = ({ 
  bill, 
  thankYouMessage, 
  setShowChangeVoteConfirm, 
  setThankYouMessage 
}) => {
  return (
    <div style={{ 
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    }}>
      <div>
        <div style={{ marginBottom: '5px' }}>
          <strong>Current Vote:</strong> {bill?.vote_count > 0 ? bill?.previous_vote : 'None'}
          {bill?.vote_count === 1 && bill?.previous_vote && (
            <span style={{ color: '#dc3545', marginLeft: '5px' }}>
              (This is your last chance to vote on this bill!)
            </span>
          )}
        </div>
        
        {!bill?.vote_count && (
          <div style={{ color: '#0d6efd' }}>
            You have 2 chances to vote on this bill. Choose carefully!
          </div>
        )}

        {bill?.vote_count >= 2 && (
          <div style={{ color: '#28a745' }}>
            You have used all your votes for this bill.
          </div>
        )}
      </div>

      {bill?.vote_count === 1 && bill?.previous_vote && !thankYouMessage && (
        <div style={{
          textAlign: 'left'
        }}>
          <p style={{ 
            color: '#856404',
            marginBottom: '15px',
            fontWeight: 'bold'
          }}>
            Do you want to change your vote?
          </p>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={() => {
                setShowChangeVoteConfirm(true);
                setThankYouMessage(null);
              }}
              style={{
                padding: '8px 20px',
                backgroundColor: '#ffc107',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Yes, change my vote
            </button>
            {/* <button
              onClick={() => setShowChangeVoteConfirm(false)}
              style={{
                padding: '8px 20px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              No, keep my vote
            </button> */}
          </div>
        </div>
      )}
    </div>
  );
};

const BillVoting = ({ selectedBill, phoneNo, onVoteSubmitted }) => {
  const [vote, setVote] = useState("");
  const [comment, setComment] = useState("");
  const [thankYouMessage, setThankYouMessage] = useState(null);
  const [showChangeVoteConfirm, setShowChangeVoteConfirm] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    setVote("");
    setComment("");
    setThankYouMessage(null);
    setShowChangeVoteConfirm(false);
  }, [selectedBill]);

  useEffect(() => {
    if (selectedBill?.bill_title && phoneNo) {
      const syncVoteStatus = async () => {
        try {
          const response = await axios.get("/api/get-vote-status", {
            params: {
              bill_title: selectedBill.bill_title,
              phoneNo: phoneNo,
              type: selectedBill.type
            }
          });
          
          if (response.status === 200) {
            onVoteSubmitted(response.data.vote_count || 0, response.data.previous_vote);
          }
        } catch (error) {
          console.error("Error syncing vote status:", error);
        }
      };
      
      syncVoteStatus();
    }
  }, [selectedBill?.bill_title, phoneNo, thankYouMessage]);

  useEffect(() => {
    if (showChangeVoteConfirm && containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [showChangeVoteConfirm]);

  const handleVoteChange = (value) => {
    setVote(value);
    setThankYouMessage(null);
  };

  const handleVoteSubmit = async () => {
    if (!vote) {
      alert("Please select a vote option before submitting.");
      return;
    }
    try {
      const payload = {
        bill: selectedBill.bill_title,
        phoneNo,
        vote,
        comment,
        type: selectedBill.type
      };
      const response = await axios.post(
        "/api/submit-eligible-vote",
        payload
      );
  
      if (response.status === 201 || response.status === 200) {
        const { voteCount } = response.data;
        
        if (voteCount >= 2) {
          setThankYouMessage("Thank you for your final vote on this bill!");
        } else {
          setThankYouMessage(`Thank you for voting ${vote}! You have one more vote remaining.`);
        }
        
        onVoteSubmitted(voteCount, vote);
      }
    } catch (error) {
      if (error.response?.status === 400) {
        alert(error.response.data.message || "You have already voted twice for this bill.");
      } else {
        console.error("Error submitting vote:", error);
        alert("An error occurred while submitting your vote.");
      }
    }
  };

  return (
    <div ref={containerRef} style={{ 
      textAlign: "left",
      backgroundColor: "white",
      padding: "20px",
      borderRadius: "5px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      minHeight: "fit-content"
    }}>
      <div style={{
        display: "flex",
        gap: "20px",
        alignItems: "flex-start",
        flexDirection: window.innerWidth <= 926 ? "column" : "row"
      }}>
        <div style={{ 
          flex: window.innerWidth <= 926 ? "none" : "1",
          width: window.innerWidth <= 926 ? "100%" : "auto"
        }}>
          <VoteStatus 
            bill={selectedBill}
            thankYouMessage={thankYouMessage}
            setShowChangeVoteConfirm={setShowChangeVoteConfirm}
            setThankYouMessage={setThankYouMessage}
          />
        </div>

        {((!selectedBill?.vote_count || 
          (selectedBill?.vote_count === 1 && selectedBill?.previous_vote && showChangeVoteConfirm)) && 
          !thankYouMessage && 
          selectedBill?.vote_count < 2) && (
          <div style={{ 
            flex: window.innerWidth <= 926 ? "none" : "1",
            width: window.innerWidth <= 926 ? "100%" : "auto",
            borderLeft: window.innerWidth <= 926 ? "none" : "1px solid #dee2e6",
            paddingLeft: window.innerWidth <= 926 ? "0" : "10px",
            display: "flex",
            flexDirection: "column",
            alignItems: window.innerWidth <= 926 ? "flex-start" : "center",
            marginTop: window.innerWidth <= 926 ? "10px" : "0"
          }}>
            <p style={{ 
              fontWeight: "bold", 
              marginBottom: '5px',
              textAlign: "left",
              width: "100%"
            }}>
              Please vote 'Yes' if you agree with the Bill becoming Law or 'No' if you disagree:
            </p>
            <div style={{ 
              display: "flex", 
              gap: "30px", 
              marginBottom: '5px',
              justifyContent: window.innerWidth <= 926 ? "flex-start" : "center",
              width: "100%"
            }}>
              <label>
                <input
                  type="radio"
                  name="vote"
                  value="Yes"
                  checked={vote === "Yes"}
                  onChange={(e) => handleVoteChange(e.target.value)}
                />
                Yes
              </label>
              <label>
                <input
                  type="radio"
                  name="vote"
                  value="No"
                  checked={vote === "No"}
                  onChange={(e) => handleVoteChange(e.target.value)}
                />
                No
              </label>
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              onClick={handleVoteSubmit}
              style={{ 
                padding: '4px 15px',
                marginTop: '2px',
                alignSelf: window.innerWidth <= 926 ? "flex-start" : "center"
              }}
            >
              Vote Now
            </button>
          </div>
        )}
      </div>

      {thankYouMessage && (
        <div style={{ 
          marginTop: '8px',
          padding: '6px',
          backgroundColor: '#d4edda',
          color: '#155724',
          borderRadius: '5px'
        }}>
          {thankYouMessage}
        </div>
      )}
    </div>
  );
};

export default BillVoting;
